import { render, staticRenderFns } from "./news_student.vue?vue&type=template&id=12622c52&scoped=true&"
import script from "./news_student.vue?vue&type=script&lang=js&"
export * from "./news_student.vue?vue&type=script&lang=js&"
import style0 from "./news_student.vue?vue&type=style&index=0&id=12622c52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12622c52",
  null
  
)

export default component.exports